export default {
  "Predicción de sueldos": "Salary prediction",
  "Explicación": "Explanation",
  "Completá el formulario siguiente y obtené una estimación del sueldo bruto que podrías estar ganando.": "Fill out the form below and get an estimate of the gross salary you could be earning.",
  "El sueldo se estima de acuerdo a un modelo armado de datos recolectados en la encuesta anónima.": "The salary is estimated according to a model armed with data collected in the anonymous survey.",
  "Si te interesa saber cómo están armados, podés leer el paso a paso": "If you are interested in knowing how they are assembled, you can read the step by step",
  "aquí": "here",
  "Los modelos se armaron con datos recolectados en la": "The models were assembled with data collected in the",
  "encuesta de sysarmy": "sysarmy survey",
  "llevada entre diciembre de 2019 y febrero de 2020.": "conducted between December 2019 and February 2020.",
  "Los resultados son a fines recreativos y no deben usarse para decisiones de contratación. El modelo discrimina por género, edad y orientación sexual, por lo que hacerlo es probablemente ilegal. La muestra usada no es representativa, por lo que los resultados no pueden generalizarse a la población en general.": "Results are for recreational purposes and should not be used for hiring decisions. The model discriminates on the basis of gender, age, and sexual orientation, so doing so is probably illegal. The sample used is not representative, so the results cannot be generalized to the general population.",
  "La información se procesa en el browser, así que ningún servidor almacena las evaluaciones que se hagan.": "The information is processed in the browser, so no server stores the evaluations that are made.",
  "Formulario interactivo": "Interactive form",
  "Edad": "Age",
  "Me identifico": "I identify myself as",
  "Hombre": "Man",
  "Mujer": "Woman",
  "Otros": "Others",
  "año": "year",
  "años": "years",
  "Dónde estás trabajando": "Where are you working",
  "Ciudad Autónoma de Buenos Aires": "Buenos Aires City",
  "GBA": "Buenos Aires City conurbation",
  "Provincia de Buenos Aires": "Buenos Aires Province",
  "Años de experiencia": "Years of expertise",
  'Menos de un año': 'Less than a year',
  'Nivel de estudios alcanzado': 'Level of studies achieved',
  'Primario': 'Elementary School',
  'Secundario': 'High School',
  'Terciario': 'Tertiary education',
  'Universitario': 'College',
  'Posgrado': 'Postgraduate',
  'Doctorado': 'PhD',
  'Estado': 'Status',
  'En curso': 'Ongoing',
  'Incompleto': 'Incomplete',
  'Completado': 'Completed',
  'Carrera': 'Career',
  'Analista Programador': 'Programming Analyst',
  "Analista de Sistemas": 'System Analyst',
  "Diseño Gráfico": 'Graphic Design',
  "Ingeniería Electrónica": 'Electronic Engineering',
  "Ingeniería en Computación": 'Computer Engineering',
  "Ingeniería en Informática": 'Computing Engineering',
  "Ingeniería en Sistemas de Información": 'Informational Systems Engineering',
  "Licenciatura en Administración": 'Degree in Administration',
  "Licenciatura en Análisis de Sistemas": 'Degree in Systems Analysis',
  "Licenciatura en Ciencias dela Computación": 'Degree in Computer Ciences',
  "Licenciatura en Informática": 'Degree in Computing',
  "Licenciatura en Sistemas de Información": 'Degree in Informational Systems',
  "Tecnicatura Superior en Programación": 'Higher Technical Degree in Programming',
  "Tecnicatura Superior en Sistemas Informáticos": 'Higher Technical Degree in Informational Systems',
  "Tecnicatura en Informática": 'Technical Degree in Computing',
  "Tecnicatura en Programación": 'Technical Degree in Programming',
  "Otro": 'Other',
  "Otra": 'Other',
  "Universidad": 'College',
  "Escuela Da Vinci": 'Da Vinci School',
  "ORT": 'ORT',
  "UADE - Universidad Argentina De la Empresa": 'UADE - Argentinian Company University',
  "UAI - Universidad Abierta Interamericana": 'UAT - Open Inter-american University',
  "UBA - Universidad de Buenos Aires": 'UBA - Buenos Aires University',
  "UCAECE - Centro de Altos Estudios en Ciencias Exactas": 'UCAECE - Center of High Studies in Exact Sciences',
  "UNC - Universidad Nacional de Córdoba": 'UNC - Cordoba National University',
  "UNICEN - Universidad Nacional del Centro de la Provincia de Buenos Aires": 'UNICEN - Center of Buenos Aires Province National University',
  "UNLP - Universidad Nacional de La Plata": 'UNLP - La Plata National University',
  "UNLaM - Universidad Nacional de La Matanza": 'UNLaM - La Matanza National University',
  "UP - Universidad de Palermo": 'UP - Palermo University',
  "USAL - Universidad del Salvador": 'USAL - El Salvador University',
  "UTN - Universidad Tecnológica Nacional": 'UTN - Technology National University',
  "Universidad Siglo 21": '21 Century University',
  'Realizaste cursos de especialización': 'Did you do any specialization course?',
  'de forma particular': 'on my own',
  'los pagó un empleador': 'provided by an employer',
  'Cantidad de empleados en tu trabajo actual': 'Number of employees at your current company',
  'Actividad principal': 'Main activity',
  'Servicios / Consultoría de Software / Digital': 'Services / Software or Digital Consultant',
  'Producto basado en Software': 'Software base product',
  'Otras industrias': 'Other',
  "¿Cuánta gente a cargo? (si no tenés, poné 0)": 'How many employees do you manage? (if you do not, enter 0)',
  '¿Contribuís a proyectos open source?': 'Do you contribute to open source?',
  'Sí': 'Yes',
  'No': 'No',
  '¿Programás como hobbie?': 'Do you code as a hobbie?',
  '¿Tenés guardias?': 'Do you have on-call schedules?',
  'activa': 'active',
  'pasiva': 'pasive',
  'Trabajo de': 'I work as',
  '¿Qué SO usás en tu laptop/PC para trabajar?': 'What OS do you use on your work computer?',
  '¿Y en tu celular?': 'And in your phone?',
  'No tengo celular / no es Smartphone': 'I do not own a phone / it is not a smartphoen',
  'Tipo de Contrato': 'Contract type',
  'Remoto (empresa de otro país)': 'Remote (company in another country)',
  'Tercerizado (trabajo a través de consultora o agencia)': 'Third party (I work through a consultory or agency)',
  'Orientación sexual': 'Sexual orientation',
  'Bisexual o queer': 'Bisexual or queer',
  '¿A qué eventos de tecnología asististe en el último año?': 'What tech events did you attend last year?',
  'Tecnologías que utilizás': 'Tech you use',
  'Beneficios extra': 'Another benefits',
  'abono de celular y/o internet': 'cellphone or internet plan',
  'capacitaciones y/o cursos': 'courses',
  'clases de idiomas': 'language classes',
  'comidas pagas / subvencionadas': 'free or discount food',
  'cuota para universidad / posgrados': 'university or postgraduate payments',
  'descuentos varios (clarín 365, club la nación, etc)': 'another discounts',
  'estacionamiento gratuito / subvencionado': 'free or discount parking',
  'gimnasios gratuitos / subvencionados': 'free or discount gym',
  'guardería': 'daycare',
  'horarios flexibles': 'flexible hours',
  'lactario en la oficina': 'office pumping room',
  'licencia de paternidad/maternidad extendida': 'extended parental leave',
  'masajes': 'massages',
  'ninguna de las anteriores': 'none of above',
  'snacks, golosinas, bebidas': 'snacks, candies, drinks',
  'stock options / rsus': 'stock options or rsu',
  'sueldo divido en dos pagos por mes': 'semimonthly salary',
  'sueldo dolarizado': 'salary in u.s. dollars',
  'vacaciones flexibles (adicionales a las reglamentarias)': 'flexible additional vacations',
  'viajes al exterior': 'travel abroad',
  'viáticos': 'commute expenses',
  'wfh (trabajar desde casa)': 'work from home',
  'Calculando...': 'Calculating...',
}
